import {
  GOOGLE_ACCESS_TOKEN,
  GOOGLE_ACCOUNTS,
  GOOGLE_COLUMNS,
  GOOGLE_OAUTH_URL,
  GOOGLE_REVOKE,
  GOOGLE_SHEETS,
  GOOGLE_SPREADSHEETS,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class GoogleController extends AuthenticatedController {
  static async getOauthUrl(
    redirectTo: string,
    app: 'gmail' | 'sheets',
    facebookPageId: number,
  ) {
    return super.get(GOOGLE_OAUTH_URL, {
      redirect_to: redirectTo,
      app,
      facebook_page_id: facebookPageId,
    });
  }
  static async getAccessToken(facebookPageId: number, accountId: number) {
    return super.get(GOOGLE_ACCESS_TOKEN, {
      facebook_page_id: facebookPageId,
      account_id: accountId,
    });
  }
  static async getAccounts(facebokPageId: number) {
    return super.get(GOOGLE_ACCOUNTS, {
      facebook_page_id: facebokPageId,
    });
  }
  static async getSpreadsheets(accountId: number) {
    return super.get(GOOGLE_SPREADSHEETS, {
      account_id: accountId,
    });
  }
  static async getSheets(accountId: number, spreadsheetId: string) {
    return super.get(GOOGLE_SHEETS, {
      account_id: accountId,
      spreadsheet_id: spreadsheetId,
    });
  }
  static async getColumns(
    accountId: number,
    spreadsheetId: string,
    sheetTitle: string,
  ) {
    return super.get(GOOGLE_COLUMNS, {
      account_id: accountId,
      spreadsheet_id: spreadsheetId,
      sheet_title: sheetTitle,
    });
  }
  static async revokeAccess(accountId: number) {
    return super.post(GOOGLE_REVOKE, {
      account_id: accountId,
    });
  }
}
